import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import OrdersTable from 'components/tables/OrdersTable/OrdersTable';
import useGlobalStyles from 'styles/globalStyles';


export default function AllOrdersPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'All Orders'}
            buttons={[
              // <CustomButton key='export' text='Export' color='primary' />
            ]}
          />
        </Box>

        <Box mt={3}>
          <OrdersTable />
        </Box>
      </Container>
    </Box>
  )
}

